import * as React from "react";
const SvgFiRrEmployeeManAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-employee-man-alt_svg__a)">
      <path
        fill="#062147"
        d="M12 12c3.309 0 6-2.691 6-6s-2.691-6-6-6-6 2.691-6 6 2.691 6 6 6m0-10c2.206 0 4 1.794 4 4s-1.794 4-4 4-4-1.794-4-4 1.794-4 4-4m9 21a1 1 0 1 1-2 0c0-3.019-1.925-5.59-4.609-6.57l-1.517 2.276 1.093 3.99c.183.666-.405 1.305-1.201 1.305h-1.532c-.796 0-1.383-.639-1.201-1.305l1.093-3.99-1.517-2.276C6.925 17.41 5 19.981 5 23.001a1 1 0 0 1-2 0c0-4.962 4.038-9 9-9s9 4.037 9 8.999"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-employee-man-alt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrEmployeeManAlt;
